import React from 'react';
import dynamicfunction from '../utils/dynamicfunction';
import { cn } from '../utils/utils';

const ViewItems = ({ children, className, onClick }) => {
  const { isArabic } = dynamicfunction();

  return (
    <div
      className={cn('flex flex-col', isArabic ? 'justify-items-end' : 'justify-items-start', onClick && 'cursor-pointer', className)}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default ViewItems;
